import { CompetitionTeamDetailDivisionEntry } from '~/apis/ssf';
import { formatBodyWeight, formatResultWeight } from '~/utils/weight';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { formatPoints } from '~/utils/points';
import { Fragment } from 'react/jsx-runtime';
import { genderNameToLabel } from '~/utils/gender';

interface Props {
  division: CompetitionTeamDetailDivisionEntry;
}

export function TeamDivisionResultTable({ division }: Props) {
  return (
    <PageLayout.Section>
      <PageLayout.SubHeading>
        {division.name}
        {division.competition_type ? ` — ${division.competition_type.description}` : ''}
        {division.gender ? ` — ${genderNameToLabel(division.gender, { mixedLabel: 'Mixad' })}` : ''}
      </PageLayout.SubHeading>

      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Placering</Table.Col>
            <Table.Col as="th">Lag</Table.Col>
            <Table.Col as="th">Förening</Table.Col>
            <Table.Col as="th">Poäng</Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {division.teams.length === 0 ? (
            <Table.Row>
              <Table.Col colSpan={4}>
                <div style={{ textAlign: 'center' }}>Inga lagresultat ännu.</div>
              </Table.Col>
            </Table.Row>
          ) : (
            division.teams.map((entry, idx) => (
              <Fragment key={entry.team?.id ?? `team-${idx}`}>
                <Table.Row>
                  <Table.Col>{entry.rank}</Table.Col>
                  <Table.Col>{entry.team?.name ?? '-'}</Table.Col>
                  <Table.Col>
                    {entry.team?.club ? (
                      <Link to={`/clubs/${entry.team.club.id}`}>{entry.team.club.name}</Link>
                    ) : (
                      '-'
                    )}
                  </Table.Col>
                  <Table.Col>{formatPoints(entry.team_points)}</Table.Col>
                </Table.Row>
                {entry.results.length > 0 && (
                  <Table.Row>
                    <Table.Col colSpan={4}>
                      <Table bg="odd">
                        <Table.Head>
                          <Table.Row>
                            <Table.Col as="th">Lyftare</Table.Col>
                            <Table.Col as="th">Kroppsvikt</Table.Col>
                            <Table.Col as="th">Knäböj</Table.Col>
                            <Table.Col as="th">Bänkpress</Table.Col>
                            <Table.Col as="th">Marklyft</Table.Col>
                            <Table.Col as="th">Total</Table.Col>
                            <Table.Col as="th">Poäng</Table.Col>
                          </Table.Row>
                        </Table.Head>
                        <Table.Body>
                          {entry.results.map(r => (
                            <Table.Row key={r.id}>
                              <Table.Col>
                                <Link to={`/lifters/${r.person.id}`}>
                                  {r.person.first_name} {r.person.last_name}
                                </Link>
                              </Table.Col>
                              <Table.Col>{formatBodyWeight(r.body_weight)}</Table.Col>
                              <Table.Col>{formatResultWeight(r.squat ?? 0)}</Table.Col>
                              <Table.Col>{formatResultWeight(r.benchpress ?? 0)}</Table.Col>
                              <Table.Col>{formatResultWeight(r.deadlift ?? 0)}</Table.Col>
                              <Table.Col>{formatResultWeight(r.total)}</Table.Col>
                              <Table.Col>{formatPoints(r.points)}</Table.Col>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </Table.Col>
                  </Table.Row>
                )}
              </Fragment>
            ))
          )}
        </Table.Body>
      </Table>
    </PageLayout.Section>
  );
}
